if (!customElements.get('product-comparison-grid')) {
  class ProductComparisonGrid extends HTMLElement {
    constructor() {
      super();
      this.grid = this.querySelector('.product-comparison-grid');
      this.rows = this.grid.querySelectorAll('tr');
      this.gridContainer = this.querySelector('.product-comparison-container');
      this.showAllButton = this.querySelector('.js-show-all');
      this.slider = this.querySelector('.product-comparison-slider');
      this.leftArrow = this.querySelector('.comparison-nav-arrow--left');
      this.rightArrow = this.querySelector('.comparison-nav-arrow--right');

      if (this.showAllButton) {
        this.showAllButton.addEventListener('click', this.handleShowAllClick.bind(this));
      }

      // Initialize scroll navigation if arrows exist
      if (this.leftArrow && this.rightArrow && this.slider) {
        this.initScrollNavigation();
      }
    }

    /**
     * Initialize scroll navigation with arrows
     */
    initScrollNavigation() {
      // Update arrow visibility on scroll
      this.slider.addEventListener('scroll', () => this.updateArrowVisibility());

      // Left arrow click
      this.leftArrow.addEventListener('click', (e) => {
        e.preventDefault();
        this.scrollByAmount(-this.getScrollAmount());
      });

      // Right arrow click
      this.rightArrow.addEventListener('click', (e) => {
        e.preventDefault();
        this.scrollByAmount(this.getScrollAmount());
      });

      // Initial arrow visibility and position
      setTimeout(() => {
        this.updateArrowVisibility();
        this.updateLeftArrowPosition();
      }, 100);

      // Update on resize
      window.addEventListener('resize', () => {
        this.updateArrowVisibility();
        this.updateLeftArrowPosition();
      });
    }

    /**
     * Position left arrow at the edge of the scrollable area (after header column)
     */
    updateLeftArrowPosition() {
      if (!this.leftArrow || !this.grid) return;
      
      const headerCell = this.grid.querySelector('.product-comparison-grid__th--left');
      if (headerCell) {
        const container = this.querySelector('.container');
        if (container) {
          const containerRect = container.getBoundingClientRect();
          const headerRect = headerCell.getBoundingClientRect();
          // Position arrow at the right edge of the header column
          const leftPosition = headerRect.right - containerRect.left - 12; // 12px = half arrow width
          container.style.setProperty('--comparison-arrow-left', `${leftPosition}px`);
        }
      }
    }

    /**
     * Get scroll amount (width of one product column)
     */
    getScrollAmount() {
      const productHeaders = this.grid.querySelectorAll('thead th:not(.product-comparison-grid__th--left)');
      if (productHeaders.length > 0) {
        return productHeaders[0].offsetWidth;
      }
      return 200; // fallback
    }

    /**
     * Scroll slider by amount
     */
    scrollByAmount(amount) {
      this.slider.scrollBy({
        left: amount,
        behavior: 'smooth'
      });
    }

    /**
     * Update arrow visibility based on scroll position
     */
    updateArrowVisibility() {
      if (!this.slider || !this.leftArrow || !this.rightArrow) return;

      const scrollLeft = Math.round(this.slider.scrollLeft);
      const scrollWidth = this.slider.scrollWidth;
      const clientWidth = this.slider.clientWidth;
      const maxScroll = scrollWidth - clientWidth;

      // Show/hide left arrow
      if (scrollLeft > 5) {
        this.leftArrow.classList.remove('comparison-nav-arrow--hidden');
      } else {
        this.leftArrow.classList.add('comparison-nav-arrow--hidden');
      }

      // Show/hide right arrow
      if (maxScroll > 5 && scrollLeft < maxScroll - 5) {
        this.rightArrow.classList.remove('comparison-nav-arrow--hidden');
      } else {
        this.rightArrow.classList.add('comparison-nav-arrow--hidden');
      }
    }

    /**
     * Handles 'click' events on the show all rows button
     * @param {object} evt - Event object.
     */
    handleShowAllClick(evt) {
      // Toggle the button text
      const buttonText = evt.target.textContent;
      evt.target.textContent = evt.target.dataset.toggleText;
      evt.target.dataset.toggleText = buttonText;

      // Set the initial max height to transition from
      const gridHeight = this.grid.clientHeight;
      this.gridContainer.style.maxHeight = `${gridHeight}px`;
      this.gridContainer.style.overflow = 'hidden';
      this.gridContainer.classList.add('is-transitioning');

      // Show/hide the relevant rows
      let heightReduction = 0;
      this.rows.forEach((row) => {
        if (row.classList.contains('js-hidden')) {
          row.classList.remove('js-hidden');
          row.dataset.wasHidden = 'true';
        } else if (row.dataset.wasHidden) {
          heightReduction += row.clientHeight;
        }
      });

      this.gridContainer.style.maxHeight = `${heightReduction > 0 ? gridHeight - heightReduction : this.grid.clientHeight}px`;

      // End of max height transition
      setTimeout(() => {
        if (heightReduction > 0) {
          // Hide the rows
          this.rows.forEach((row) => {
            if (row.dataset.wasHidden === 'true') {
              row.classList.add('js-hidden');
              row.removeAttribute('was-hidden');
            }
          });
        }

        // Reset the height back to auto
        this.gridContainer.style.maxHeight = '';
        this.gridContainer.style.overflow = '';
        this.gridContainer.classList.remove('is-transitioning');
      }, (parseFloat(window.getComputedStyle(this.gridContainer).transitionDuration) * 1000));
    }
  }

  customElements.define('product-comparison-grid', ProductComparisonGrid);
}
